export default __webpack_public_path__ + "locales/fr/DeleteThirdPartyDialog.json?hash=584431e3b40d710ff346ab2d7dc2e3e6";